'use strict';

import generatePayload from 'promptpay-qr';
import qrcode from 'qrcode';

const MOBILE_NUMBER = '0986742291';

async function generatePromptPayQRCode(amount) {
  const payload = generatePayload(MOBILE_NUMBER, { amount });

  const options = { type: 'png', width: 800, height: 800, color: { dark: '#003b6a', light: '#f7f8f7' } };
  return await new Promise((resolve, reject) => {
    qrcode.toDataURL(payload, options, (err, png) => {
      if (err) {
        return reject(err);
      }
      else {
        resolve(png)
      }
    });
  })
};

export { generatePromptPayQRCode };